<div class="listview__container_core" dropdown (onShown)="onShown()" (onHidden)="onHidden()">
  <a dropdownToggle class="top-nav__notify" (click)="openTasks()">
    <img src="assets/images/message-32.svg" style="width:38px">
    <div *ngIf="unReadTasks" style="position: absolute;bottom: -0.5rem; left: 2rem;" class="badge-circle"></div>
  </a>


  <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu--block" role="menu">
    <div class="listview listview--hover" *ngIf="loading">
      <div class="loader loader-sm loader-search"></div>
    </div>
    <div class="listview listview--hover" *ngIf="!loading">
      <div class="listview__content-items_core">
        <perfect-scrollbar class="perfect-scrollbar_core">
          <ng-container *ngFor="let tasks of tasksData">

            <span class="date_item"> {{ tasks?.key | translate }} </span>

            <div *ngFor="let task of tasks?.value" [class.cursor-pointer]="task?.url" class="listview__item"
              [class.readed]="task?.read" (click)="navigate(task)">

              <div class="task-line">
                <h3 class="listview__heading m-0">
                  {{ task.processNumber }}
                  <small class="ball-blue float-left pr-3">
                    <span class="text-muted task-hour">{{ task.screenDate | hourMinute }}</span>
                  </small>
                </h3>
                <span class="task-content"> {{ task.applicationContent }} </span>
                <span class="text-muted task-port"> {{ task?.port?.code }} - {{ task?.port?.description }} </span>
              </div>

            </div>

          </ng-container>

          <div class="card shadow-none border-0" *ngIf="error">
            <div class="">
              <div class="text-center">
                <i class="zmdi zmdi-alert-circle-o zmdi-hc-4x text-muted mb-3"></i>
                <div class="h5 text-muted">Não foi possível obter as tarefas</div>
              </div>
            </div>
          </div>
          <div class="card border-0 shadow-none" *ngIf="tasksData?.length===0 && !error && !loading">
            <div class="mt-4">
              <div class="text-center">
                <div class="h5 text-muted">Não existem tarefas</div>
              </div>
            </div>
          </div>

        </perfect-scrollbar>
      </div>

      <span class="see-all" (click)="openTasksPage()" *ngIf="!error"> {{ 'generic.see.all' | translate }}
        <img src="assets/images/navigation-arrow-right-35.svg">
      </span>

    </div>
  </div>

</div>
